import { render, staticRenderFns } from "./TftUniversityShowdownSchedule.vue?vue&type=template&id=13dd77e4&"
import script from "./TftUniversityShowdownSchedule.vue?vue&type=script&lang=js&"
export * from "./TftUniversityShowdownSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TftUniversityShowdownSchedule.vue?vue&type=style&index=0&id=13dd77e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports